import * as api from '../api'
import useApiMutation from './useApiMutation'

export default function useCreateGroup() {
  return useApiMutation({
    mutationFn: async (data: { name: string; users: string[]; managers: string[] }) =>
      api.post('group', {
        name: data.name,
        is_managed: true,
        members: data.users,
        managers: data.managers,
      }),
  })
}
